<template>
  <HubContainer id="taxesHub">

    <HubSection large icon="icon/hub/taxes.svg"
                :title="$t('taxes.title')"
                :description="$t('taxes.description')"
                :buttonAction="goToTaxes">
    </HubSection>

    <HubSection large icon="icon/hub/taxes-group.svg"
                :title="$t('tax_groups.title')"
                :description="$t('tax_groups.description')"
                :buttonAction="goToTaxGroup">
    </HubSection>

  </HubContainer>
</template>

<script>
  import HubSection from "@/components/HubSection";
  import HubContainer from "@/components/HubContainer";

  export default {
    name: "taxesHub",

    components: { HubSection, HubContainer },

    mounted() {
      this.$store.state.pageTitleTranslationKey = "advanced_navigation.taxes";
      this.$store.state.pageIcon = "/icon/nav/taxes.svg";
    },

    methods: {
      goToTaxes() {
        this.$router.push(this.$router.buildContext("/taxes"));
      },
      goToTaxGroup() {
        this.$router.push(this.$router.buildContext("/tax-group"));
      }
    }
  }
</script>